import React, { Component } from "react";
import styles from './Movie.module.css';

export class Movie extends Component {
  render() {
    return (
      <div className={styles.main}>
        <div className={styles.movie}>
          <figure>
            <img
              src={this.props.image}
            />
            <figcaption>
              <h2 className={styles.movieTitle}>{this.props.title}</h2>
            </figcaption>
          </figure>
        </div>
        <div className={styles.movieName}>{this.props.title}</div>
      </div>
    );
  }
}

export default Movie;
